module.exports = __webpack_public_path__ + "static/ticket-front-ba5751a6d4f12a3e11d031bb1997c5ad.png";